import { MotionSourceType } from './MotionSource';
import { MuteMotionSource } from './MuteMotionSource';

export class LinearLoopMotionSource extends MuteMotionSource {
  type = MotionSourceType.LinearLoop;

  getLevelAt(millis: number, option: any = undefined): number {
    const position = (millis % this.getLoopDuration()) / this.getLoopDuration();
    return position;
  }
}



// WEBPACK FOOTER //
// ./src/motion/LinearLoopMotionSource.ts